(function () {
  'use strict';

  // Strip trailing currency code: "£7.20 GBP" → "£7.20"
  function stripCurrencyCode(price) {
    return price.replace(/\s+[A-Z]{3}$/, '').trim();
  }

  // Find the visible text node inside .product-price--original (after the visually-hidden span)
  function getPriceTextNode(el) {
    for (var i = el.childNodes.length - 1; i >= 0; i--) {
      var node = el.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) return node;
    }
    return null;
  }

  function applySubscriptionPrice(productEl, input) {
    var priceBlock = productEl.querySelector('[data-update-block="price-extended"]');
    if (!priceBlock) return;

    var priceOriginalEl = priceBlock.querySelector('.product-price--original');
    if (!priceOriginalEl) return;

    var textNode = getPriceTextNode(priceOriginalEl);
    if (!textNode) return;

    // Snapshot the unmodified price the first time we touch this block
    if (!priceBlock.dataset.basePrice) {
      priceBlock.dataset.basePrice = textNode.textContent;
    }

    var isSubscription = input.dataset.radioType === 'selling_plan';
    var variantPrice = input.dataset.variantPrice;
    var compareAtPrice = input.dataset.variantCompareAtPrice;

    if (isSubscription && variantPrice) {
      textNode.textContent = ' ' + stripCurrencyCode(variantPrice) + ' ';

      // Show original price struck through
      if (compareAtPrice) {
        var compareEl = priceBlock.querySelector('.product-price--compare');
        if (!compareEl) {
          compareEl = document.createElement('del');
          compareEl.className = 'product-price--compare';
          priceOriginalEl.insertAdjacentElement('afterend', compareEl);
        }
        var compareSpan = document.createElement('span');
        compareSpan.textContent = stripCurrencyCode(compareAtPrice);
        compareEl.replaceChildren(compareSpan);
      }
    } else {
      // Restore baseline price and remove compare-at
      textNode.textContent = priceBlock.dataset.basePrice;
      var existing = priceBlock.querySelector('.product-price--compare');
      if (existing) existing.remove();
    }
  }

  // Delegate: catch subscription radio changes anywhere on the page
  document.addEventListener('change', function (e) {
    if (e.target.type !== 'radio') return;
    if (!e.target.closest('.shopify_subscriptions_app_container')) return;
    var productEl = e.target.closest('[data-js-product-component]');
    if (productEl) applySubscriptionPrice(productEl, e.target);
  });

  // On variant reload the theme replaces [data-update-block] innerHTML with fresh server HTML.
  // Clear the cached base price so it re-snapshots correctly after the DOM settles.
  //
  // NOTE: This relies on the "Local" theme (v3.1.1) dispatching a bubbling `reload` event
  // on the product component element after a variant change. See component-product-form.js
  // lines ~302/320. If pricing ever gets stuck after a variant switch, check whether the
  // theme still fires this event and update accordingly.
  document.addEventListener('reload', function (e) {
    var productEl = e.target && e.target.closest
      ? e.target.closest('[data-js-product-component]')
      : null;
    if (!productEl) return;
    setTimeout(function () {
      var priceBlock = productEl.querySelector('[data-update-block="price-extended"]');
      if (priceBlock) delete priceBlock.dataset.basePrice;
    }, 0);
  }, true);

}());
